export const BUSINESS_ERROR_CODES = new Set([
    // 사용자 관련
    "USER-E001", //로그인 과정에서 오류 발생했습니다.
    "USER-E002", //사용자를 찾을 수 없습니다.
    "USER-E003", //비밀번호가 일치하지 않습니다.
    "USER-E004", //승인 대기중 입니다.
    "USER-E005", //리프레시 토큰 만료기간이 지났습니다.
    "USER-E006", //승인 거절 상태입니다.
    "USER-E007", //아이디는 영문 또는 숫자로 6~30자리여야 합니다.

    // 식당관련


    // 게시판 관련
    "BBS-E001",  //

    // FEIGN 관련
    "FEIGN-E001", // feign 관련 에러

    // FILE 관련
    "FILE-E001",  //이미지 파일 저장 오류 발생
    "FILE-E002",  //파일 다운로드 중 오류 발생

    //예약 관련
    "REVERSE_E001", //현재 예약 가능한 수량이 없습니다. 모든 예약이 완료되었습니다.
    "REVERSE_E002", //예약에 실패하였습니다.
    "REVERSE_E003", //장애로 인해 처리 할 수 없습니다. 관리자에 문의 바랍니다.
    "REVERSE_E005", //예약 가능 시간이 마감되었습니다.
    "REVERSE_E006", //예약 취소 가능 시간이 마감되었습니다.
    "REVERSE_E007", //노쇼 페널티로 인해 해당 코너의 예약이 제한되어 있습니다.
]);


// HTTP 상태 기반으로 시스템 장애 여부 판단
export function isSystemLevel(status) {
    if (!status) return true;   // 응답 없음(네트워크 끊김, 타임아웃 등)
    if (status >= 500) return true; // 서버 내부 오류
    return false;
}

// 응답 바디의 code로 비즈니스 에러인지 판단
export function isBusinessError(code) {
    if (!code) return false;

    // 문자열 코드 기반 관리
    if (typeof code === 'string') {
        return BUSINESS_ERROR_CODES.has(code);
    }

    return false;
}
